import Hero from "../components/Hero";
import PlanTrip from "../components/PlanTrip";
import Faq from "../components/Faq";
import Download from "../components/Download";
import Footer from "../components/Footer";
import Functions from "../components/Functions";
import Sliders from "../components/Sliders";

function Home() {
  return (
    <>
      <Hero />
      <PlanTrip />
      <Functions />
      <Sliders />
      <Faq />
      <Download />
      <Footer />
    </>
  );
}

export default Home;
